export enum IntegrationStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
}

export enum Integration {
  BugZilla = 'BugZilla',
  Jira = 'Jira',
  TestsigmaTestManagement = 'TestsigmaTestManagement',
  JiraServer = 'JiraServer',
  SauceLabs = 'SauceLabs',
  BrowserStack = 'BrowserStack',
  PrivateGrid = 'PrivateGrid',
  Slack = 'Slack',
  MS_Teams = 'MS_Teams',
  MS_Teams_Connector = 'MS_Teams_Connector',
  Freshrelease = 'Freshrelease',
  Azure = 'Azure',
  Mantis = 'Mantis',
  BackLog = 'BackLog',
  Youtrack = 'Youtrack',
  GoogleChat = 'GoogleChat',
  Trello = 'Trello',
  Linear = 'Linear',
  LambdaTest = 'LambdaTest',
  Kobiton = 'Kobiton',
  ClickUp = 'ClickUp',
  XrayCloud = 'XrayCloud',
  XrayServer = 'XrayServer',
  TestRail = 'TestRail',
  ZephyrCloud = 'ZephyrCloud',
  QTest = 'QTest',
  Monday = 'Monday',
  Azure_Devops = 'azure-devops',
  Circle_ci = 'circle-ci',
  Bamboo = 'bamboo',
  Aws = 'aws',
  Travis_ci = 'travis-ci',
  Jenkins = 'jenkins',
  Codeship = 'codeship',
  Custom = 'custom',
  Figma = 'figma',
  GitHub = 'GitHub',
  GitHub_CI_CD = 'GitHub_CI_CD',
  GitLab = 'Gitlab',
  GitLab_CI_CD = 'GitLab_CI_CD',
}
